import type { CatalogFilters } from "./useCatalogList";

/**
 * Si hay un filtro que sólo el índice puede contestar (xcons-docs#434). Los borradores no
 * están indexados, así que con uno de estos activo no se mezclan: aparecerían sin filtrar,
 * como si cumplieran.
 *
 * Vive aparte del hook para poder testearla sin arrastrar la config del entorno.
 */
export const filtraPorIndice = (f: CatalogFilters): boolean =>
  Object.values(f.atributos ?? {}).some((ids) => ids.length > 0) ||
  (f.categorias?.length ?? 0) > 0 ||
  // "Sin dueño" no alcanza a un borrador: siempre tiene a quien lo creó (xcons-docs#447).
  !!f.dueno;
